import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Typography } from '@mui/material';

import WaeButton from '../../../../../../components/Button';
import { BLACK, PRIMARY_PURPLE } from '../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../theme/fontConstants';
import SectionCard from '../SectionCard';

const styles = {
  subHeaderStyle: {
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[500],
    my: 0.5,
  },
  textStyle: {
    fontSize: '16px',
  },
  buttonStyle: {
    mt: 3,
    backgroundColor: PRIMARY_PURPLE[70],
    color: BLACK[0],
    fontWeight: 'bold',
    textTransform: 'none',
  },
};

const UserAccountActivationToggleCard = ({ content, onActionClick, isLoading }) => (
  <SectionCard>
    <Typography sx={styles.subHeaderStyle} data-testid={content.card.headerTestId}>
      {LanguageConverterV2(content.card.headerKey)}
    </Typography>
    <Typography sx={styles.textStyle}>{LanguageConverterV2(content.card.bodyKey)}</Typography>
    <WaeButton
      variant="contained"
      fullWidth
      sx={styles.buttonStyle}
      dataTestId={content.card.actionTestId}
      onClick={onActionClick}
      disabled={isLoading}
      showIndeterminateProgress={isLoading}
    >
      {LanguageConverterV2(content.card.actionLabelKey)}
    </WaeButton>
  </SectionCard>
);

UserAccountActivationToggleCard.propTypes = {
  content: PropTypes.shape({
    card: PropTypes.shape({
      headerKey: PropTypes.string.isRequired,
      bodyKey: PropTypes.string.isRequired,
      actionLabelKey: PropTypes.string.isRequired,
      headerTestId: PropTypes.string.isRequired,
      actionTestId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  onActionClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default UserAccountActivationToggleCard;
